"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_deprecated_1 = require('@angular/router-deprecated');
var http_1 = require('@angular/http');
var angular2_text_mask_1 = require('angular2-text-mask');
var clientinfo_service_1 = require('../../clientinfo.service');
var PhoneComponent = (function () {
    function PhoneComponent(clientInfo, router, http) {
        this.clientInfo = clientInfo;
        this.router = router;
        this.http = http;
        this.phone = '';
    }
    PhoneComponent.prototype.ngOnInit = function () {
        this.phone = this.clientInfo.userOrder.phone;
    };
    // Makes request to create authorization order in Oracle
    PhoneComponent.prototype.makeOrder = function (value) {
        this.clientInfo.maskedPhone = value;
        var unmasked = value.replace(/[^0-9]+/g, '');
        this.clientInfo.userOrder.phone = unmasked;
        if (this.clientInfo.userOrder.phone.length == 10) {
            var activeEl = document.activeElement;
            activeEl.blur();
            this.clientInfo.socket.emit('orderAdded', this.clientInfo.userOrder);
            var headers = new http_1.Headers();
            headers.append('Content-Type', 'application/json');
            this.router.navigate(['PhoneCall']);
            this.http.post('/api/user/makeorder', JSON.stringify(this.clientInfo.userOrder), { headers: headers })
                .map(function (response) { return response.json(); })
                .subscribe(function (response) {
                if (response.code == 1)
                    console.log('done!');
                else
                    console.log(response.code);
            });
        }
    };
    PhoneComponent = __decorate([
        core_1.Component({
            selector: 'smartwifi-phone',
            template: require('./phone.template.html'),
            directives: [angular2_text_mask_1.default]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof clientinfo_service_1.ClientInfoService !== 'undefined' && clientinfo_service_1.ClientInfoService) === 'function' && _a) || Object, (typeof (_b = typeof router_deprecated_1.Router !== 'undefined' && router_deprecated_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _c) || Object])
    ], PhoneComponent);
    return PhoneComponent;
    var _a, _b, _c;
}());
exports.PhoneComponent = PhoneComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/phone/phone.component.ts
 ** module id = 938
 ** module chunks = 1
 **/